import { render } from "./editRateCode.vue?vue&type=template&id=13f6df48&scoped=true"
import script from "./editRateCode.vue?vue&type=script&lang=js"
export * from "./editRateCode.vue?vue&type=script&lang=js"

import "./editRateCode.vue?vue&type=style&index=0&id=13f6df48&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f6df48"]])

export default __exports__